export default __webpack_public_path__ + "static/media/arrow.749cca41.svg";